import config from '../config';
import { datadogRum } from '@datadog/browser-rum';
import { datadogTags } from './datadogConstants';

export function initializeDatadogRum(): void {
  const { datadogRumClientToken, datadogEnv } = config;

  const isProduction = datadogEnv === 'production';

  if (isProduction) {
    try {
      datadogRum.init({
        applicationId: '372961c0-5714-40d3-a859-92dce6a6562c',
        clientToken: datadogRumClientToken,
        site: 'datadoghq.eu',
        service: 'cato',
        env: datadogEnv,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: [config.catoApiUrl, config.emailApiUrl, config.chatApiUrl].filter(
          (url): url is string => Boolean(url)
        ),
        traceSampleRate: 100
      });

      datadogRum.setGlobalContext({
        ...datadogRum.getGlobalContext(),
        ...datadogTags
      });

      connect.agent(function (agent) {
        const username = agent.getConfiguration().username;
        if (username) {
          setDatadogRumUser(username);
        }
      });

      datadogRum.startSessionReplayRecording();
    } catch (e) {
      throw new Error(e instanceof Error ? e.message : String(e));
    }
  }
}

export const setDatadogRumUser = (email: string): void => {
  if (datadogRum) {
    datadogRum.setUser({
      email
    });
  }
};
